export default __webpack_public_path__ + "static/media/gallery-wip-handle_03.6e8de8e9.jpg";